import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=0e804275"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e804275')) {
      api.createRecord('0e804275', component.options)
    } else {
      api.reload('0e804275', component.options)
    }
    module.hot.accept("./SystemConfig.vue?vue&type=template&id=0e804275", function () {
      api.rerender('0e804275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Systems/SystemConfig.vue"
export default component.exports